module.exports = __webpack_public_path__ + "img/dd4.d32ed6d1.jpg";